export default __webpack_public_path__ + "static/media/banner_ 768x500_Tablet.5e858d0b.png";